import React from 'react'
import { Helmet as ReactHelmet, HelmetProps } from 'react-helmet'

export const Helmet: React.FC<HelmetProps> = ({ ...props }) => {
  return <ReactHelmet defer={false} {...props} />
}
